import CityPageTemplate from "../city-template/CityPageTemplate";
import { southfieldConfig } from "./data";

export default function SouthfieldPage() {
  return <CityPageTemplate config={southfieldConfig} />;
}